import { List, ListItem, Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const OverviewStep: IProductTour = {
  title: 'Explore the Overview Page',
  menu: 'overview',
  submenu: 'overview',
  steps: [
    {
      title: "Let's Explore the Landing Page Overview!",
      content: (
        <ProductTourContent spacing={1}>
          See a quick snapshot of conversations, sentiment, and trends from all
          media sources.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Overview Menu',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to open the overview menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Search Keyword or Brand',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Add a keyword or brand in the search box to view more specific data.
          You can refine it further by including or excluding certain terms.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Advanced Search Settings',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Use advanced filters to narrow results by source type, sentiment,
          emotion, age generation, language, location, or author.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Advanced Search Settings',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Use advanced filters to narrow results by source type, sentiment,
          emotion, age generation, language, location, or author.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stats Overview',
      content: (
        <ProductTourContent spacing={1}>
          <Typography fontSize="12px">
            Key metrics providing a snapshot of cross-channel conversations:
          </Typography>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Total Talk - Overall number of conversations
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Average Talk - Average talk volume in the selected timeframe
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Positive Talk - Total positive conversations
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Negative Talk - Total negative conversations
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Anger Emotion - Mentions expressing anger
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Joy Emotion - Mentions expressing joy
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Stream Panel',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          A list of the most popular conversations and articles collected from
          social media and online news.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Day-to-Day Conversation: A trend chart showing how talk and
              talkers change over time. You can switch to weekly, monthly,
              quarterly, or yearly views to spot spikes or drops.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Day-to-Day Media Conversation: A trend chart visualizing how talk
              evolves across different media types (social, online, print,
              broadcast) over time.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Sentiment by Media: Shows how sentiment is distributed across each
              media channel, helping you see which platforms lean more positive,
              negative, or neutral.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top 5 Social Media Post: Displays the top 5 social media posts
              ranked by engagement.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top 5 Print News Article: Shows the top 5 print news articles with
              the highest prominence.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top Hashtag: Most frequently used hashtags.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top Locations: Most frequently mentioned locations.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Sentiment Analysis: Shows the distribution of sentiment (positive,
              neutral, negative) across conversations.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Emotion Analysis: Displays key emotions such as joy, sadness,
              anger, trust, and more found in conversations.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Media Coverage Popularity: A summary of how widely your topic is
              covered across media channels (social media, online news,
              broadcast, print).
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Brand Share of Voice by Media: Shows your brand's conversation
              share compared to other media channels.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Word Cloud (Talk Word Cloud): A visualization of the most
              frequently mentioned words in conversations.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Overview Metric',
      content: (
        <ProductTourContent spacing={1}>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top Online News Portals: A list of online news portals with the
              highest number of related articles.
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              Top Print Media: Print media outlets with the highest article
              volume on your topic.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          All steps are complete. You've successfully finished this stage and
          are now ready to continue exploring and using all available features.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
